import { createContext } from 'react'

const propsContext = createContext({
    // survey live props
    questions: [], pages: [], page: 0, onPage:() => {}, replys: [], caution: {}, refComments: [], onModule: () => {}, scrollerObj: {}, design: {}
})

export default propsContext